import React from 'react'
import MemberApplicationTaskList from '../../features/MemberApplicationTaskList/MemberApplicationTaskList' 

// import "./MembershipApplicationList.scss"

const MembershipApplicationList = () => {
  return (
    <div className="membership-application-list-page">
     
      <MemberApplicationTaskList />
    </div>
  )
}

export default MembershipApplicationList
